(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]',
        ),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this),
      );
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this),
      );
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      );
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ).toString(),
      );
    }

    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-home"] && !Shopify.designMode) return;
  try {
    
  // Reveal-on-scroll for the homepage sections.
  (function () {
    var section = document.querySelector('.v3home');
    if (!section) return;
    var els = section.querySelectorAll('.v3home-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('v3home-reveal--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('v3home-reveal--in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16 });
    els.forEach(function (el) { io.observe(el); });
  })();

  // Hide Shopify Inbox chat while the hero is in view.
  // Adds body.v3home-in-hero whenever any part of the hero is
  // visible in the viewport, removes it once the user scrolls
  // past. CSS in the stylesheet block handles the suppression
  // with the same selector vectors used by the Letters drawer.
  (function () {
    var hero = document.querySelector('.v3home-hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        document.body.classList.toggle('v3home-in-hero', e.isIntersecting);
      });
    }, { threshold: 0.01 });
    io.observe(hero);
  })();

  } catch(e) { console.error(e); }
})();
})();
